
export { LucideIcon } from "/codebuild/output/src1051443037/src/packages/shared-components/src/components/LucideIcon.tsx"